<div class=" body_container text-grey">
  <app-component-navigation></app-component-navigation>
  <div class="row w-100 ms-1 flex-grow-1 overflow-hidden">
    <div class="w-12 p-0">
      <app-configurator-left-panel></app-configurator-left-panel>
    </div>
    <div class="w-88 d-flex flex-column h-100">
      <!-- <div class="topPanel" style="display: flex; height: 28px;">
        @if (activeEntity == 'SyncHPC') {
          <button type="button"
                  class="default-btn float-end"
                  title="Update authentication method to use for log in."
                  (click)="updateAuthenticationConfiguration()"  style="margin-top:-6px">
            <span class="bi bi-pencil-square"></span>
            Authentication
          </button>
          <button type="button"
                  class="default-btn float-end"
                  title="Configure UI of logIn page."
                  (click)="updateLogInPageUIConfiguration()"  style="margin-top:-6px">
            <span class="bi bi-pencil-square"></span>
            Customize
          </button>
          <button type="button"
                  class="default-btn float-end"
                  title="Send broadcast message."
                  (click)="addServiceBroadcastMessage()"  style="margin-top:-6px">
            <span class="bi bi-chat-square-text">
            </span>
            Broadcast
          </button>
        }
        <button type="button" class="default-btn" triggers="hover" ngbTooltip="Refresh Configurator" (click)='refreshComponent()' style="margin-top:-6px">
          <span class="bi bi-arrow-clockwise"></span> Refresh
        </button>
      </div> -->
      <div class="flex-grow-1 h-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
